<template>
  <div id="app">
   <loading :active.sync="isLoading" 
        :can-cancel="false" 
       
        color="#80A6FF"
        background-color="#ffffff"
        :height="106"
        :width="106"
        :is-full-page="fullPage"></loading>
  <!--  <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>-->
    <router-view/>
  </div>
</template>

<style lang="stylus">

</style>
<script>

import Vue from 'vue'
import update from './mixins/update'
import Loading from 'vue-loading-overlay';
    // Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
//@ts-ignore
import Notiflix from "notiflix";

export default {
  name: 'App',
  components: {
    Loading
  },
  data: function () {
    return {
       isLoading: false,
       counterloading:0,
       fullPage: true,

     elemento:null,
      datas:false,
    
      fullPage: true,
      active_alerta:false,
      msg_alerta:"",
       active_success:false,
      msg_success:"",
    }
  },
     mixins: [update],
  methods:{
    show_alert(msg){ 

 Notiflix.Report.Failure( 'MetricaDigital', 
 '"'+msg+'." ', 'Aceptar' ); 


    },
    success(msg){
       Notiflix.Report.Success( 'MetricaDigital',
        '"'+msg+'." ', 'Aceptar' ); 
    },
     splashs(status){ 
   console.log(this.splash);
     this.splash=false; 
      console.log(this.splash);
    },
     loadingf(status){
        this.isLoading=status;
        return;
       if(status){
         console.log('+1')
         ++this.counterloading;
       }else{
          console.log('-1')
         --this.counterloading;
       }
       console.log(this.counterloading,'-----');
       if(this.counterloading>0){
         console.log('muestra')
         this.isLoading=true;
       }else{
         console.log('oculta')
         this.isLoading=false;
       }
      //this.isLoading=status;
    },
  },
  created(){
     
let host=window.location.hostname;

   
   
  },
  mounted(){
    //Notiflix.Loading.Standard('Loading...');
var th=this;
this.$store.subscribe((mutation, state) => {
 console.log('state ----')
 // console.log(state)

  if(mutation.type=='SETLOADING'){
    console.log('SETLOADING')
    console.log(mutation)

  }
	localStorage.setItem('store', JSON.stringify(state));
   


});
  this.$root.$on('loading', function(status){
     //console.log(status)
        th.loadingf(status);
    });
   
 this.$root.$on('alerta_show', function(msg){
      th.show_alert(msg);
      
    });
     this.$root.$on('success', function(msg){

      th.success(msg);
      
    });

    this.$root.$on('splash', function(status){

      
      th.splashs(status)
      
    });
  }
  ,
  beforeCreate() {

	if(localStorage.getItem('store')) {
		let store = JSON.parse(localStorage.getItem('store'));
		this.$store.commit('initialiseStore',store);
	
	}
		
  },
    	 metaInfo () { 
        return { 
            title: (this.elemento==null)?'MetricaDigital':this.elemento.titulo, 
            meta: [ 
                {name: 'description', content: (this.elemento==null)?'MetricaDigital':this.elemento.parrafo}, 
                {propiedad: 'og: title', content: (this.elemento==null)?'Sistema de metricas':this.elemento.titulo}, 
                {propiedad: 'og: site_name ', contenido:(this.elemento==null)?'MetricaDigital':this.elemento.tutulo}, 
                {propiedad:' og: descripción ', contenido:(this.elemento==null)?'Sistema de metricas':this.elemento.parrafo}, 
                {propiedad:' og : tipo ', contenido:' perfil '},
                {propiedad: 'og: url', contenido: 'https://metricadigital.com '}, 
                {propiedad:' og: image ', content: (this.elemento==null)?'':this.elemento.icon}     
            ] 
        } 
    }, 

}
</script>
<style 
>
:root {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
}
.beta {
 
  background-color: #20c9976b
}
.beta_ac
 {
 
  background-color:  #216f5747
}
.hide_b{
  display:none!important

}
.fullCard{
    position:fixed;
    z-index:400000;
    left:0px;
    top:0px;
    height:100vh;
    width:100vw;
}
table td span{
    font-size:13px
}
table th span{
    font-size:13px
}

.collapsed-sidebar .secondary-sidebar {
    width: 200px!important;
}
</style>